export function isNotificationSupported(): boolean {
  return 'Notification' in window;
}

export async function requestNotificationPermission(): Promise<NotificationPermission> {
  if (!isNotificationSupported()) {
    return 'denied';
  }

  if (Notification.permission === 'granted') {
    return 'granted';
  }

  if (Notification.permission === 'denied') {
    return 'denied';
  }

  return Notification.requestPermission();
}

export function showNotification(title: string, options?: NotificationOptions): Notification | null {
  if (!isNotificationSupported()) {
    return null;
  }

  if (Notification.permission !== 'granted') {
    return null;
  }

  const notification = new Notification(title, {
    icon: '/favicon.ico',
    badge: '/favicon.ico',
    ...options,
  });

  // Auto-close after 10 seconds
  setTimeout(() => notification.close(), 10000);

  return notification;
}

export function showResearchCompleteNotification(): Notification | null {
  return showNotification('Your research is ready', {
    body: 'Click to view your detailed response.',
    tag: 'research-complete',
    requireInteraction: true,
  });
}
